import * as React from 'react';

import InsightsReportsQueriesCollabary from './collabary/InsightsReportsQueriesCollabary';

import { __t, applyTranslations } from 'utils/language';

import type {
  GeneralProps,
  Query,
  QuerySave,
  Report
} from 'modules/insights/reports/types';

import './insights-reports-queries.scss';

applyTranslations(require('./insights-reports-queries.i18n.json'));

type Props = {
  report: Report,
  isActionEvent: boolean,
  isInvalidQueriesSelection?: boolean,
  onSaveQuery: (data: QuerySave) => void,
  onUpdateQuery: (query: Query) => void,
  onDuplicateQuery: (query: Query) => void,
  onDeleteQuery: (props: GeneralProps) => void
};

const MSG_KEY = 'insights_reports_queries';

class InsightsReportsQueries extends React.PureComponent<Props> {
  renderCollabary(): React.ReactNode {
    const {
      report,
      isActionEvent,
      onSaveQuery,
      onUpdateQuery,
      onDuplicateQuery,
      onDeleteQuery
    } = this.props;

    return (
      <div className="sov-queries__collabary">
        <InsightsReportsQueriesCollabary
          report={report}
          isActionEvent={isActionEvent}
          onSaveQuery={onSaveQuery}
          onUpdateQuery={onUpdateQuery}
          onDuplicateQuery={onDuplicateQuery}
          onDeleteQuery={onDeleteQuery}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { isInvalidQueriesSelection } = this.props;

    return (
      <div className="insights-reports-queries">
        {this.renderCollabary()}
        {isInvalidQueriesSelection && (
          <div className="insights-reports-queries__error">
            {__t(`${MSG_KEY}.errors.no_queries_selected`)}
          </div>
        )}
      </div>
    );
  }
}

export default InsightsReportsQueries;
